var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBadgeSuccess = function SvgBadgeSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z",
    fill: "#9C9A9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42672 5.39245C2.39036 5.42869 2.3615 5.47174 2.34182 5.51915C2.32213 5.56655 2.31201 5.61737 2.31201 5.6687C2.31201 5.72003 2.32213 5.77086 2.34182 5.81826C2.3615 5.86567 2.39036 5.90872 2.42672 5.94495L3.67088 7.18912C3.73649 7.25451 3.82533 7.29123 3.91796 7.29123C4.01059 7.29123 4.09945 7.25451 4.16505 7.18912L7.57172 3.78329C7.60792 3.74714 7.63665 3.70421 7.65625 3.65695C7.67585 3.60969 7.68593 3.55903 7.68593 3.50787C7.68593 3.45671 7.67585 3.40605 7.65625 3.35879C7.63665 3.31153 7.60792 3.2686 7.57172 3.23245C7.49875 3.15958 7.39984 3.11865 7.29671 3.11865C7.19359 3.11865 7.09468 3.15958 7.02171 3.23245L3.91922 6.31579L2.97671 5.38995C2.9036 5.31703 2.80456 5.27608 2.7013 5.27608C2.59804 5.27608 2.49899 5.31703 2.42588 5.38995L2.42672 5.39245Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadgeSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge-success.7069c45f.svg";
export { ForwardRef as ReactComponent };